function fixedItem() {
	const $fixedItem = $('.js-fixed-item');
	const $logo = $('.l-header__logo');

	$(window).on('scroll', () => {
		const $trigger = $('.js-trigger').offset().top;
		const scrollTop = $(window).scrollTop();
		const scrollPosition = window.innerHeight + scrollTop;
		const footHeight = $('.l-footer').offset().top;

		if(window.innerWidth < 768) {
			if(scrollTop >= $trigger) {
				$fixedItem.addClass('is-fixed');
				$fixedItem.removeClass('is-fixed-close');
			} else {
				if($fixedItem.hasClass('is-fixed')) {
					$fixedItem.removeClass('is-fixed');
					$fixedItem.addClass('is-fixed-close');
				}
			}

			if(scrollPosition >= footHeight) {
				$fixedItem.removeClass('is-fixed');
				$fixedItem.addClass('is-fixed-close');
			}
		} else {
			if(scrollPosition >= footHeight) {
				$logo.removeClass('is-fixed');
				$logo.addClass('is-fixed-close');
			} else {
				$logo.addClass('is-fixed');
				$logo.removeClass('is-fixed-close');
			}

			if(scrollTop === 0) {
				$logo.addClass('is-fixed');
				$logo.removeClass('is-fixed-close');
			}
		}
	});
}

$(window).on('load', () => {
	fixedItem();
});
